module.exports = __webpack_public_path__ + "img/linkedin.a8853520.svg";